import SongsUpload from './SongsUpload';

export default SongsUpload;
export type { ISongsUploadProps, ISongsUploadRef } from './SongsUpload.types';
export * from './utils';
